import React from 'react'

import IconCircle from '../_icon_circle'

const IconCircleDefault = (props) => {
  return (
    <div>
      <IconCircle
          icon="rocket"
          size="md"
          {...props}
      />
    </div>
  )
}

export default IconCircleDefault
